import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing(1)};
  width: 100%;

  .row {
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};

    &.second {
      align-items: center;
      overflow: hidden;
    }
  }
`;

export const firstRowActionsContainerStyle = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  margin-left: auto;
`;
